export default __webpack_public_path__ + "static/media/pointChart.e928e00a.svg";